import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import img from "../../../assets/images/valeur.png";
import "./index.scss";
import { FleshA } from "../../../assets/icons/FleshA";
import { useTranslation } from "react-i18next";

const ValeursSection = () => {
  const { t } = useTranslation();

  return (
    <section className="valeurs-section py-5">
      <div className="valeurs-container h-100">
        <Row className="h-100 g-5">
          {/* Image à gauche */}
          <Col md={6} className="image-col">
            <div className="image-card h-100">
              <img
                src={img}
                alt={t("values.imageAlt")}
                className="img-fluid h-100"
              />
              <h2 className="section-title-monile d-md-none d-block">
                {t("values.titleLine1")}
                <br />
                {t("values.titleLine2")}
              </h2>
              <div className="overlay1">
                <div className="overlay-content">
                  <h3>
                    {t("values.overlayLine1")}
                    <br /> {t("values.overlayLine2")}
                  </h3>
                  <Button variant="light" className="arrow-btn">
                    <FleshA />
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          {/* Texte à droite */}
          <Col
            md={6}
            className="text-col h-100 d-flex flex-column flex-column-mobile-reverse">
            <h2 className="section-title d-none d-md-block">
              {t("values.titleLine1")}
              <br />
              {t("values.titleLine2")}
            </h2>

            <div className="full-height d-flex justify-content-end flex-grow-1 flex-column-mobile-reverse flex-md-column flex-column-reverse">
              <div className="tags mt-4">
                <span>{t("values.tags.excellence")}</span>
                <span>{t("values.tags.commitment")}</span>
                <span>{t("values.tags.innovation")}</span>
                <span>{t("values.tags.expertise")}</span>
                <span>{t("values.tags.impact")}</span>
                <span className="active">{t("values.tags.agility")}</span>
              </div>

              <p className="description mt-4">
                {t("values.descriptionLine1")}
                <br />
                {t("values.descriptionLine2")}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ValeursSection;
